import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { SubscriptionSeats } from '../../contractAdmin/styledComponents';
import TeamIcon from '../shared/TeamIcon';
// import UserIcon from '../shared/UserIcon';
import SubscriptionStudySelector from '../AccountDetails/SubscriptionStudySelector';
import { CROSSTAB_FEATUREID } from '../../../constants';

const TeamListItem = ({
  text,
  itemId,
  selected,
  disabled,
  handleSelection,
  handleExpendTree,
  listid,
  children,
  position,
  hidden,
  accessStart,
  accessEnd,
  activationKey,
  contractId,
  seats,
  selectedBox,
  occupiedSeats,
}) => {
  const subscriptions = contractId.split('*');
  const isRldSubscription = subscriptions.includes('RLD');
  const handleItemSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    handleSelection(selectedElementId, clearExisting, shiftKey);
  };
  const availableSeats = seats - occupiedSeats;
  let renderAvailableSeats = '';
  if (!selectedBox) {
    renderAvailableSeats = (
      <span>
        {'Available seats'} <strong>{availableSeats}</strong> /{' '}
        <strong>{seats}</strong>
      </span>
    );
  }
  const renderChildren = () => {
    const renderChild = (
      <SubscriptionStudySelector
        studies={children}
        featureID={CROSSTAB_FEATUREID}
      />
    );
    return (
      <div className="dropdown-menu-children">
        <div className="dropdown-items">{renderChild}</div>
      </div>
    );
  };

  const hasChild = !_.isEmpty(children);
  let toggleIcon = String.fromCharCode(9658);
  if (hasChild) {
    toggleIcon = String.fromCharCode(9660);
  }

  if (hidden) {
    return null;
  }
  if (activationKey && isRldSubscription) {
    return (
      <li id={itemId} className="dropdown-menu-multi-select">
        <div disabled className="disabled-sel-roles dropdown-menu-item">
          <button className="expend-tree-button" type="button">
            <span className="icon">{toggleIcon}</span>
          </button>
          <a style={{ cursor: 'not-allowed' }}>
            <TeamIcon size="18px" fill="#b2bece" />{' '}
            <span className="menu-text">
              {text} {renderAvailableSeats}
              {accessStart !== undefined
                ? ` ( ${new Date(
                    accessStart
                  ).toLocaleDateString()}  -  ${new Date(
                    accessEnd
                  ).toLocaleDateString()} ) `
                : ''}
            </span>
          </a>
        </div>
      </li>
    );
  }

  return (
    <li
      onMouseDown={handleItemSelection}
      id={itemId}
      className={
        selected
          ? 'dropdown-menu-multi-select active'
          : 'dropdown-menu-multi-select'
      }
    >
      <div
        disabled={disabled}
        className={
          disabled
            ? 'disabled-sel-roles dropdown-menu-item'
            : 'dropdown-menu-item'
        }
      >
        <button
          className="expend-tree-button"
          type="button"
          onClick={e => handleExpendTree(e, listid, hasChild, position)}
        >
          <span className="icon">{toggleIcon}</span>
        </button>
        <a>
          <TeamIcon size="18px" fill="#b2bece" />{' '}
          <span className="menu-text">
            {text}
            {accessStart !== undefined
              ? ` ( ${new Date(
                  accessStart
                ).toLocaleDateString()}  -  ${new Date(
                  accessEnd
                ).toLocaleDateString()} ) `
              : ''}
            <SubscriptionSeats>{renderAvailableSeats}</SubscriptionSeats>
          </span>
        </a>
      </div>
      {hasChild && renderChildren()}
    </li>
  );
};

TeamListItem.propTypes = {
  handleSelection: PropTypes.func,
  text: PropTypes.string,
  itemId: PropTypes.number,
  selected: PropTypes.bool,
  listid: PropTypes.number,
  position: PropTypes.string,
  handleExpendTree: PropTypes.func,
  children: PropTypes.instanceOf(Array),
  activationKey: PropTypes.bool,
  selectedBox: PropTypes.bool,
};

export default TeamListItem;
